import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { stockKeys } from "./query-keys";

type Marketplace = components["parameters"]["Marketplace"];

export interface RecalculateTarget {
  sku: string;
  marketplace: Marketplace;
}

/**
 * "Calculate" row action (PRD v1.8 §4.6.3.2-B).
 *
 * Non-destructive recompute of derived stock columns for the given
 * (sku, marketplace) rows. NEVER changes multiplier / fake / lock —
 * the destructive reset-to-defaults lives in `useCalculateReset`.
 */
export function useRecalculate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (targets: RecalculateTarget[]) => {
      const { data, error } = await apiClient.POST("/v1/stock/recalculate", {
        body: { targets },
      });
      if (error) throw error;
      return data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: stockKeys.lists });
    },
  });
}
